export default __webpack_public_path__ + "static/media/femiMed_zdjecie_glowne.6db95efc.webp";